// Nederlands (F1). Sleutels met `one`/`other` zijn meervoudsvormen: geen Intl.PluralRules
// (pas Safari 13, ONTWERP.md §3.1), dus expliciete vormen per taal.
import { designNl } from './design.nl.js';
import { kioskBoardNl } from './kioskBoard.nl.js';
import { foodNl } from './food.nl.js';
import { familyNl } from './family.nl.js';
import { kamersNl } from './kamers.nl.js';
import { kioskRemindersNl } from './reminders.nl.js';
import { kioskWeatherNl } from './kioskWeather.nl.js';
import { kioskTimerNl } from './kioskTimer.nl.js';
import { hallwayNl } from './hallway.nl.js';
import { kioskPrivacyNl } from './kioskPrivacy.nl.js';
import { kioskMoveNl } from './kioskMove.nl.js';
import { readAloudNl } from './readAloud.nl.js';
import { todoNl } from './todo.nl.js';
export const nl = {
    locale: 'nl-NL',
    weekdays: ['maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag', 'zondag'],
    weekdaysShort: ['ma', 'di', 'wo', 'do', 'vr', 'za', 'zo'],
    months: [
        'januari',
        'februari',
        'maart',
        'april',
        'mei',
        'juni',
        'juli',
        'augustus',
        'september',
        'oktober',
        'november',
        'december',
    ],
    /** Korte maandnamen ("8 mrt"), niet de eerste drie letters ("maa"). */
    monthsShort: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
    // Designsysteem (docs/DESIGN.md): pictogrammen, kleuren, componentlabels, lege staten.
    design: designNl,
    // Huishouden (sprint 4): boodschappen, recepten, weekmenu, voorraad, kiosk Eten.
    food: foodNl,
    // w4 familie (docs/DESIGN.md §8.F): wensen, kalenders, familie, berichten.
    family: familyNl,
    // Sprint 4: kamers, schoonmaakkast, kindslot, voorlezen (docs/DESIGN.md 8.K12–K14, 8.W23–W25).
    kamers: kamersNl,
    // 0021: herinneringen bij afspraken (de oproep op het bord).
    reminders: kioskRemindersNl,
    // 0026 weer: losse woorden op het bord (de zinnen maakt de server).
    weather: kioskWeatherNl,
    // Timer op het bord (oprichter 1 okt 2026).
    timer: kioskTimerNl,
    // Golf 6b (0043): het bord in de gang van een gedeelde woning (hallway.nl.ts).
    hallway: hallwayNl,
    // 0036: melding als het gezinsbord verwijderd gaat worden.
    privacy: kioskPrivacyNl,
    move: kioskMoveNl,
    readAloud: readAloudNl,
    // 0058: to-do's onder de taken van een lid (todo.nl.ts).
    todo: todoNl,
    common: {
        adjustBoard: 'Aanpassen',
        refreshBoard: 'Verversen',
        create: 'Nieuw maken',
        agendaBoard: 'Agenda',
        today: 'Vandaag',
        tomorrow: 'Morgen',
        now: 'Nu',
        later: 'Straks',
        done: 'Klaar',
        cancel: 'Annuleren',
        confirm: 'Bevestigen',
        back: 'Terug',
        close: 'Sluiten',
    },
    kiosk: {
        // Woonkamerbord sprint 2/3 (kioskBoard.nl.ts).
        ...kioskBoardNl,
        agenda: 'Agenda',
        tasks: 'Taken',
        rewards: 'Beloningen',
        nothingToday: 'Vandaag niets gepland',
        nothingMore: 'Niets meer vandaag',
        noTasks: 'Geen taken voor vandaag',
        allDone: 'Alles klaar!',
        /** Rustig, buiten het thema Kinderen. */
        allDoneCalm: 'Alles is klaar',
        allDay: 'Hele dag',
        everyone: 'Iedereen',
        next: 'Hierna',
        // Nu/Straks-strook (ONTWERP.md §7.1): "over 25 min" / "nog 20 min".
        startsIn: 'over {time}',
        busyFor: 'nog {time}',
        minutesShort: '{count} min',
        hoursShort: '{h} u {m} min',
        tasksProgress: '{done} van {total} klaar',
        pairTitle: 'Koppel deze tablet',
        pairHint: 'Voer deze code in op je telefoon:',
        pairScan: 'Of scan de QR-code met je telefoon',
        pairWaiting: 'Wachten op goedkeuring…',
        pairStarting: 'Code ophalen…',
        pairExpired: 'Code verlopen, nieuwe code wordt opgehaald…',
        pairNoConnection: 'Geen verbinding met de server, opnieuw proberen…',
        // 0040: koppelen met de QR-code uit de ouderapp (het bord leest #k=… uit het adres).
        pairQrClaiming: 'Koppelen met de QR-code…',
        pairQrInvalid: 'Deze QR-code is verlopen of al gebruikt. Maak een nieuwe in de ouderapp, of koppel met de code op dit scherm.',
        pairQrLimit: 'Er kan geen tablet meer bij in jullie abonnement. Koppel eerst een andere tablet los in de ouderapp.',
        // Review g6a r1: 429 (te veel pogingen vanaf dit netwerk); de code kan nog goed zijn.
        pairQrBusy: 'Even te veel pogingen. Wacht een minuut en scan de QR-code dan opnieuw.',
        pairQrOffline: 'Geen verbinding, dus de QR-code werkte niet. Scan hem opnieuw, of koppel met de code op dit scherm.',
        offline: 'Geen verbinding, laatste stand van {time}',
        offlineBadge: 'Geen verbinding',
        // Render-guard (review kiosk-constraints ronde 2): leesbaar paneel i.p.v. een lege muur.
        renderFailed: 'Het bord kan de agenda nu niet tonen en probeert het opnieuw.',
        // Verbruikt recovery token (§6.3 suspect): neutraal, geen alarm voor de kinderen.
        checkInApp: 'Controleer deze tablet in de ouderapp',
        // Lokale dag valt buiten het gecachte venster (> 21 dagen zonder sync, §5.5).
        staleData: 'Geen actuele gegevens',
        standaloneTitle: 'Zet het gezinsbord op het beginscherm',
        standaloneBody: 'Tik in Safari op Delen en dan op "Zet op beginscherm". Open het bord daarna via dat icoon, anders blijft de koppeling niet bewaard.',
        points: { one: '{count} punt', other: '{count} punten' },
        tasksLeft: { one: 'Nog {count} taak', other: 'Nog {count} taken' },
        // 0035: gepauzeerd door AMUMIN Beheer; rustig, geen alarm voor de kinderen.
        paused: 'Alleen kijken',
        // Review g4 ux r2: na een tik op een taak, beloning, vinkje of bericht terwijl het bord pauzeert.
        pausedHint: 'Het bord staat even op alleen kijken. Afvinken kan straks weer.',
    },
    web: {
        appName: 'AMUMIN Family Board',
        loginTitle: 'Inloggen',
        email: 'E-mailadres',
        password: 'Wachtwoord',
        login: 'Inloggen',
        forgotPassword: 'Wachtwoord vergeten?',
        noAccount: 'Nog geen account?',
        register: 'Account aanmaken',
        // Algemeen
        save: 'Opslaan',
        add: 'Toevoegen',
        edit: 'Bewerken',
        remove: 'Verwijderen',
        loading: 'Laden…',
        retry: 'Opnieuw proberen',
        close: 'Sluiten',
        reload: 'Opnieuw laden',
        none: 'Geen',
        errorGeneric: 'Er ging iets mis. Probeer het opnieuw.',
        errorNetwork: 'Geen verbinding met de server.',
        errorNotFound: 'Deze pagina bestaat niet.',
        /** 0029: een onderdeel dat voor dit gezin uit staat (Instellingen · Modules). */
        moduleOff: 'Dit onderdeel staat uit voor jullie gezin.',
        /** 0023/0043: dit lid geeft zelf toestemming (consent_self_required). */
        consentSelfRequired: 'Iemand van 16 jaar of ouder geeft hier zelf toestemming voor. Kijk of de leeftijden van de leden kloppen en probeer het dan opnieuw.',
        versionConflict: 'Dit is intussen door iemand anders gewijzigd. De lijst is opnieuw geladen; probeer het nog eens.',
        rateLimited: 'Te veel pogingen. Probeer het over {seconds} seconden opnieuw.',
        sessionExpired: 'Je sessie is verlopen. Log opnieuw in.',
        // Navigatie en schil
        nav: {
            today: 'Vandaag',
            agenda: 'Agenda',
            members: 'Leden',
            devices: 'Apparaten',
            security: 'Beveiliging',
            household: 'Huishouden',
            logout: 'Uitloggen',
        },
        timeInAmsterdam: 'Tijd in Amsterdam',
        browserZoneDiffers: 'Je browser staat in een andere tijdzone; alle tijden hier zijn in Amsterdamse tijd.',
        householdSwitch: 'Actief huishouden',
        // Inloggen
        sharedComputer: 'Gedeelde of openbare computer',
        sharedComputerHint: 'Je sessie verloopt na 24 uur en deze browser wordt niet vertrouwd.',
        stayLoggedIn: 'Ingelogd blijven',
        invalidCredentials: 'E-mailadres of wachtwoord klopt niet.',
        emailNotVerified: 'Bevestig eerst je e-mailadres via de link in de e-mail.',
        outsideTrustedNetwork: 'Je bent buiten een vertrouwd netwerk. Log opnieuw in met je wachtwoord en een e-mailcode.',
        forgetToLogout: 'Vergeet niet uit te loggen als je klaar bent.',
        // 0035: gepauzeerd door AMUMIN Beheer (423 household_paused).
        householdPaused: 'Je gezinsbord staat even op alleen kijken. Wijzigen kan nu niet.',
        lockedOut: 'Te veel mislukte pogingen. Probeer het later opnieuw.',
        // E-mailcode
        codeTitle: 'E-mailcode',
        codeIntro: 'We hebben een 6-cijferige code gestuurd naar {email}. Hij is 10 minuten geldig.',
        codeLabel: 'Code uit de e-mail',
        codeInvalid: 'Voer de 6 cijfers uit de e-mail in.',
        codeWrong: 'Die code klopt niet. Nog {count} pogingen.',
        codeWrongPlain: 'Die code klopt niet.',
        codeLocked: 'Te veel foute codes. Log opnieuw in om een nieuwe code te krijgen.',
        codeExpired: 'De code is verlopen. Log opnieuw in om een nieuwe code te krijgen.',
        trustBrowser: 'Vertrouw deze browser 30 dagen',
        trustBrowserHint: 'Tot {date} vragen we in deze browser geen e-mailcode meer.',
        resend: 'Code opnieuw sturen',
        resendIn: 'Opnieuw sturen kan over {seconds} s',
        resent: 'Nieuwe code verstuurd; de vorige code is ongeldig.',
        notMeLink: 'Dit was ik niet',
        noPendingCode: 'Er staat geen inlogpoging open. Log eerst in.',
        networkConfirmIntro: 'Bevestig het nieuwe vertrouwde netwerk met de 6-cijferige code die we naar {email} hebben gestuurd.',
        // Registreren
        registerTitle: 'Account aanmaken',
        passwordHint: 'Minimaal 12 tekens.',
        passwordTooShort: 'Gebruik minimaal 12 tekens.',
        passwordTooLong: 'Gebruik maximaal 256 tekens.',
        emailInvalid: 'Controleer je e-mailadres.',
        passwordRepeat: 'Herhaal wachtwoord',
        passwordMismatch: 'De wachtwoorden zijn niet gelijk.',
        registerDone: 'Controleer je e-mail',
        registerDoneText: 'We hebben een bevestigingslink gestuurd naar {email}. Klik erop om je account te activeren.',
        alreadyAccount: 'Al een account?',
        emailTaken: 'Er bestaat al een account met dit e-mailadres.',
        passwordBreached: 'Dit wachtwoord komt voor in een datalek. Kies een ander wachtwoord.',
        privateEmailHint: 'Tip: gebruik een privé-e-mailadres, niet je kantooradres.',
        // Verifiëren
        verifyTitle: 'E-mailadres bevestigen',
        verifyIntro: 'Klik op de knop om je e-mailadres te bevestigen.',
        verifyButton: 'Bevestigen',
        verifying: 'Bezig met bevestigen…',
        verifyDone: 'Je e-mailadres is bevestigd. Je kunt nu inloggen.',
        verifyInvalid: 'Deze link is ongeldig of verlopen.',
        tokenMissing: 'Deze link is niet compleet. Open de link uit de e-mail opnieuw.',
        toLogin: 'Naar inloggen',
        // Wachtwoord vergeten
        resetTitle: 'Wachtwoord vergeten',
        resetIntro: 'Vul je e-mailadres in. Als er een account bestaat, sturen we een link om je wachtwoord te wijzigen (60 minuten geldig).',
        resetSend: 'Link sturen',
        resetSent: 'Als er een account bestaat met {email}, is er een e-mail onderweg.',
        resetConfirmTitle: 'Nieuw wachtwoord',
        newPassword: 'Nieuw wachtwoord',
        resetConfirmButton: 'Wachtwoord wijzigen',
        resetDone: 'Je wachtwoord is gewijzigd. Alle vertrouwde browsers zijn vergeten; bij de volgende login vragen we opnieuw een e-mailcode.',
        resetInvalid: 'Deze resetlink is ongeldig of verlopen.',
        // Dit was ik niet
        notMeTitle: 'Dit was ik niet',
        notMeIntro: 'Iemand heeft met je wachtwoord geprobeerd in te loggen. Was jij dat niet? Dan zetten we je account op slot.',
        notMeWhatHappens: 'Wat er gebeurt als je op de knop drukt:',
        notMeStep1: 'De openstaande inlogpoging wordt geblokkeerd.',
        notMeStep2: {
            one: '{count} vertrouwde browser wordt vergeten.',
            other: '{count} vertrouwde browsers worden vergeten.',
        },
        notMeStep2Unknown: 'Alle vertrouwde browsers worden vergeten.',
        notMeStep3: {
            one: '{count} openstaande inlogcode wordt ongeldig.',
            other: '{count} openstaande inlogcodes worden ongeldig.',
        },
        notMeStep4: 'Je ontvangt een e-mail om een nieuw wachtwoord te kiezen.',
        notMeButton: 'Ja, dit was ik niet',
        notMeDone: 'Gedaan. Controleer je e-mail voor de link om een nieuw wachtwoord te kiezen.',
        notMeInvalid: 'Deze link is ongeldig of al gebruikt.',
        // Step-up
        stepUpTitle: 'Bevestig met je wachtwoord',
        stepUpIntro: 'Voor deze actie vragen we je wachtwoord opnieuw, ook thuis. Dat geldt 10 minuten.',
        stepUpButton: 'Bevestigen',
        stepUpWrong: 'Wachtwoord klopt niet.',
        stepUpCancelled: 'Actie geannuleerd.',
        // Wizard
        wizardTitle: 'Je huishouden instellen',
        wizardIntro: 'Een paar dingen om te beginnen; alles is later aan te passen.',
        wizardHouseholdName: 'Naam van het huishouden',
        wizardHouseholdHint: 'Staat bovenaan het bord, bijvoorbeeld "Familie Jansen".',
        wizardYou: 'Jouw naam op het bord',
        wizardPinTitle: 'Ouder-PIN',
        wizardPinPlaceholder: 'Komt later: de PIN voor de ouder-modus op de tablet zet je hier met een wachtwoordbevestiging.',
        wizardInviteTitle: 'Tweede ouder uitnodigen',
        wizardInvitePlaceholder: 'Komt later: uitnodigen per e-mail; de ander krijgt dezelfde rechten in dit huishouden.',
        wizardTrustTitle: 'Dit netwerk vertrouwen',
        wizardTrustHint: 'Regel je onder Beveiliging: dan vragen we thuis geen e-mailcode.',
        wizardSaved: 'Huishouden opgeslagen.',
        householdNameRequired: 'Vul een naam in.',
        // Vandaag
        todayTitle: 'Vandaag',
        todayEmpty: 'Vandaag niets gepland.',
        tasksTitle: 'Taken',
        tasksEmpty: 'Geen taken voor vandaag.',
        allDay: 'Hele dag',
        everyone: 'Iedereen',
        doneBy: 'Klaar',
        quickAdd: 'Snel toevoegen',
        // Agenda
        agendaTitle: 'Agenda',
        newEvent: 'Snel een afspraak',
        newTask: 'Snel een taak',
        title: 'Titel',
        date: 'Datum',
        start: 'Begin',
        duration: 'Duur (minuten)',
        forWhom: 'Voor wie',
        allDayLabel: 'Hele dag',
        icon: 'Icoon',
        iconNone: 'Geen icoon',
        location: 'Locatie',
        createEvent: 'Afspraak toevoegen',
        createTask: 'Taak toevoegen',
        eventCreated: 'Afspraak toegevoegd.',
        taskCreated: 'Taak toegevoegd.',
        titleRequired: 'Vul een titel in.',
        titleTooLong: 'Maximaal 120 tekens.',
        dateInvalid: 'Kies een geldige datum (JJJJ-MM-DD).',
        memberRequired: 'Kies minstens één lid.',
        startInvalid: 'Kies een begintijd (UU:MM).',
        durationInvalid: 'De duur is minimaal 5 en maximaal 1440 minuten.',
        listFor: 'Agenda voor {date}',
        showDay: 'Toon',
        deleteEvent: 'Afspraak verwijderen',
        deleteTask: 'Taak verwijderen',
        itemDeleted: 'Verwijderd.',
        noEventsDay: 'Geen afspraken op deze dag.',
        noTasksDay: 'Geen taken op deze dag.',
        // Leden
        membersTitle: 'Leden',
        membersIntro: 'Iedereen die op het bord staat, met of zonder login.',
        addMember: 'Lid toevoegen',
        editMember: 'Lid bewerken',
        memberName: 'Naam',
        memberKind: 'Soort',
        kindAdult: 'Volwassene',
        kindChild: 'Kind',
        kindHelper: 'Helper',
        color: 'Kleur',
        avatarIcon: 'Avatar-icoon',
        ageBand: 'Leeftijdsband',
        ageBandNone: 'Niet ingevuld',
        nameRequired: 'Vul een naam in.',
        nameTooLong: 'Maximaal 40 tekens.',
        memberSaved: 'Lid opgeslagen.',
        colorNames: {
            orange: 'Oranje',
            skyblue: 'Hemelsblauw',
            bluishgreen: 'Blauwgroen',
            yellow: 'Geel',
            blue: 'Blauw',
            vermillion: 'Vermiljoen',
            reddishpurple: 'Roodpaars',
            black: 'Zwart',
        },
        // Apparaten
        devicesTitle: 'Apparaten',
        devicesEmpty: 'Nog geen tablet gekoppeld.',
        pairDevice: 'Koppelen',
        deviceName: 'Naam',
        room: 'Kamer',
        status: 'Status',
        lastSeen: 'Laatst gezien',
        lastSync: 'Laatste sync',
        statusActive: 'Actief',
        statusRevoked: 'Ingetrokken',
        statusSuspect: 'Verdacht',
        online: 'Online',
        offline: 'Offline',
        never: 'Nog nooit',
        justNow: 'zojuist',
        minutesAgo: { one: '{count} minuut geleden', other: '{count} minuten geleden' },
        hoursAgo: { one: '{count} uur geleden', other: '{count} uur geleden' },
        daysAgo: { one: '{count} dag geleden', other: '{count} dagen geleden' },
        rename: 'Hernoemen',
        revoke: 'Intrekken',
        revokeConfirm: 'Weet je zeker dat je "{name}" wilt intrekken? De tablet toont dan binnen een minuut het koppelscherm.',
        revokeYes: 'Ja, intrekken',
        deviceRevoked: 'Apparaat ingetrokken.',
        deviceSaved: 'Apparaat opgeslagen.',
        appVersion: 'Versie',
        standalone: 'Beginscherm-app',
        swState: 'Service worker',
        storageOk: 'Opslag',
        clockOffset: 'Klokafwijking',
        // Koppelen
        pairTitle: 'Tablet koppelen',
        pairIntro: 'Voer de code in die de tablet toont.',
        pairCode: 'Code',
        pairReviewIntro: 'Controleer de code op je tablet. Kies daarna de naam en kamer.',
        pairConnect: 'Deze tablet koppelen',
        pairMatch: 'Komt deze code overeen met de code op je tablet?',
        pairChangeCode: 'Andere code invoeren',
        pairDetails: 'Apparaatdetails',
        pairNameLabel: 'Naam voor je tablet',
        pairNameHint: 'Je kunt deze naam later wijzigen.',
        pairNext: 'Ga terug naar je tablet. Het bord opent daar automatisch.',
        pairCodeInvalid: 'De code bestaat uit 8 tekens, bijvoorbeeld 1234-5678.',
        pairLookup: 'Code controleren',
        pairNotFound: 'Onbekende of verlopen code. Controleer de code op de tablet.',
        pairTooMany: 'Te veel foute codes in deze sessie. Log opnieuw in.',
        pairUserAgent: 'Browser',
        pairPlatform: 'Platform',
        pairCountry: 'Land',
        pairStarted: 'Gestart',
        pairUnknown: 'onbekend',
        pairApprove: 'Goedkeuren',
        pairApproved: 'Tablet "{name}" gekoppeld. Het bord verschijnt binnen enkele seconden.',
        roomRequired: 'Kies een kamer.',
        toDevices: 'Naar apparaten',
        // Beveiliging
        securityTitle: 'Beveiliging',
        trustedNetworksTitle: 'Vertrouwde netwerken',
        trustedNetworksIntro: 'Op een vertrouwd netwerk vragen we geen e-mailcode; je wachtwoord blijft altijd nodig.',
        trustThisNetwork: 'Dit netwerk vertrouwen',
        trustServerWan: 'Internetadres van de server vertrouwen',
        currentPrefix: 'Je zit nu op {prefix}',
        serverWanLabel: 'Internetadres van de server: {ip}',
        currentPrefixUnknown: 'Je internetadres is onbekend.',
        networkNoSuggestion: 'Dit netwerk kan niet als vertrouwd netwerk worden toegevoegd (bijvoorbeeld een lokaal of gedeeld providernetwerk).',
        networkAlreadyTrusted: 'Dit netwerk is al vertrouwd.',
        addNetwork: 'Netwerk toevoegen',
        label: 'Label',
        labelRequired: 'Vul een label in.',
        kind: 'Soort',
        kindCidr: 'Netwerk (CIDR, bijv. 192.168.1.0/24)',
        kindIp: 'Eén adres (IPv4)',
        kindServerWan: 'Internetadres van de server (volgt automatisch)',
        kindDdns: 'DDNS-hostnaam',
        value: 'Waarde',
        valueInvalid: 'Ongeldige waarde voor dit soort netwerk.',
        valueIpv6: 'IPv6 wordt nog niet ondersteund.',
        valueCgnat: 'Dit adres hoort bij een gedeeld providernetwerk (CGNAT) en kan niet vertrouwd worden.',
        scope: 'Geldt voor',
        scopeHousehold: 'Het hele huishouden',
        scopeIdentity: 'Alleen mij',
        rememberDefault: '"Ingelogd blijven" staat standaard aan op dit netwerk',
        officeWarning: 'Iedereen achter dit adres slaat de e-mailcontrole over — is dit een vast zakelijk adres?',
        mobileHint: 'Op mobiel of 4G? Gebruik dan liever "Vertrouw deze browser 30 dagen" bij het inloggen.',
        networkCreated: 'Netwerk toegevoegd. Bevestig het met de e-mailcode.',
        networkConfirmed: 'Netwerk bevestigd. Op dit netwerk vragen we geen e-mailcode meer.',
        unconfirmed: 'Nog niet bevestigd',
        confirmedAt: 'Bevestigd',
        lastMatched: 'Laatst gematcht',
        disabledLabel: 'Uit',
        enabledLabel: 'Aan',
        disable: 'Uitzetten',
        enable: 'Aanzetten',
        thisNetwork: 'dit netwerk',
        noNetworks: 'Nog geen vertrouwde netwerken.',
        trustedBrowsersTitle: 'Vertrouwde browsers',
        trustedBrowsersIntro: 'Na wachtwoord + e-mailcode vertrouwen we een browser 30 dagen; daarna vragen we opnieuw een code.',
        thisBrowser: 'Deze browser',
        issued: 'Uitgegeven',
        trustedUntil: 'Vertrouwd tot {date}',
        lastUsedAt: 'laatst gebruikt {when}',
        expiresOn: 'verloopt {date}',
        todayAt: 'vandaag {time}',
        yesterdayAt: 'gisteren {time}',
        expires: 'Verloopt',
        lastUsed: 'Laatst gebruikt',
        forget: 'Vergeten',
        forgetOthers: 'Alle andere browsers vergeten',
        noTrustedBrowsers: 'Geen vertrouwde browsers.',
        browserForgotten: 'Browser vergeten.',
        sessionsTitle: 'Sessies',
        routeLabel: 'Route',
        routeBrowser: 'vertrouwde browser',
        routeNetwork: 'vertrouwd netwerk',
        routeOnce: 'eenmalig (24 uur)',
        routeNone: 'geen',
        thisSession: 'Deze sessie',
        revokeSession: 'Intrekken',
        logoutEverywhere: 'Overal uitloggen',
        logoutForget: 'Uitloggen en deze browser vergeten',
        sessionRevoked: 'Sessie ingetrokken.',
    },
};
//# sourceMappingURL=nl.js.map